module.exports = __webpack_public_path__ + "img/ok.6c0976f6.svg";